document.addEventListener("DOMContentLoaded", () => {
  const reviewCarousels = document.querySelectorAll(".reviews-slider");

  reviewCarousels.forEach(reviewCarousel => {
    const itemsPerPage = parseInt(reviewCarousel.getAttribute('data-perpage'));
    const gapItems = parseInt(reviewCarousel.getAttribute('data-gap'));

    const slider = new Splide( reviewCarousel, {
      type: 'slide',
      rewind: true,
      pagination: true,
      arrows: true,
      perPage: itemsPerPage,
      gap: gapItems,
      breakpoints: { 1024: { perPage: 2, gap: 16, padding: { right: '5rem' } }, 750: { perPage: 1, gap: 16, padding: { right: '4rem' } } }
    });

    slider.mount();
  });
});